var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustAutonomy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6128 33.251L10.5113 40.3548L14.8551 40.1226L16.8259 44.0004L20.9274 36.8967",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4663 33.251L38.5678 40.3548L34.224 40.1226L32.2532 44.0004L28.1517 36.8967",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6468 21.323C40.6468 30.3379 33.3385 37.646 24.3234 37.646C15.3082 37.646 8 30.3379 8 21.323C8 12.3081 15.3082 5 24.3234 5C33.3385 5 40.6468 12.3081 40.6468 21.323Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8574 26L22.1502 26.7071L22.8574 27.4142L23.5645 26.7071L22.8574 26ZM31.5645 18.7071L32.2716 18L30.8574 16.5858L30.1502 17.2929L31.5645 18.7071ZM16.436 20.9928L22.1502 26.7071L23.5645 25.2929L17.8502 19.5786L16.436 20.9928ZM23.5645 26.7071L31.5645 18.7071L30.1502 17.2929L22.1502 25.2929L23.5645 26.7071Z",
    fill: "#C63031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustAutonomy);
export default __webpack_public_path__ + "static/media/Trust & Autonomy.48e75b4ed022f4605ba18f9e6f3fb38a.svg";
export { ForwardRef as ReactComponent };